import React from 'react';
import DashboardTabs from '@components/common/Dashboard/DashboardTabs';
import GlobalMuteBanner from '@src/components/notification-channel/GlobalMute/GlobalMuteBanner';
import { Wrapper, Content } from './styled';
import ManualAlertContext from '../manualAlert/context';
import { useToggle, useDelete } from './hooks';

interface Options {
  showTabs?: boolean;
}

export const ManualBase = (WrappedComponent, options: Options = {}) => {
  const { showTabs = true } = options;
  // eslint-disable-next-line react/display-name
  return (props) => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const toggleAlerts = useToggle();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const deleteAlerts = useDelete();

    return (
      <Wrapper>
        {showTabs && <DashboardTabs id="manual_alerts" />}
        <GlobalMuteBanner />
        <Content>
          <ManualAlertContext.Provider
            value={{
              actions: {
                toggleAlerts,
                deleteAlerts,
              },
            }}
          >
            <WrappedComponent {...props} />
          </ManualAlertContext.Provider>
        </Content>
      </Wrapper>
    );
  };
};
